module.exports = __webpack_public_path__ + "static/media/pricing-hero-bottom-mob.c0baf0e1.png";